var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { datadogLogs } from '@datadog/browser-logs';
import { BASE_INFORM_API_URL } from './services/constants';
var LOG_LEVELS = ['debug', 'info', 'warn', 'error'];
var defaultOptions = {
    autoForwardLogs: false,
    enableLogs: false,
    enableInfo: false,
    enableWarn: false,
    enableError: false,
    enableDebug: false,
};
var DatadogLogger = /** @class */ (function () {
    function DatadogLogger() {
        this.options = defaultOptions;
        this.initialized = false;
    }
    DatadogLogger.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (this.initialized) {
                            console.warn('DatadogLogger is already initialized.');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetch("".concat(BASE_INFORM_API_URL, "/settings/DataDogConfigurations"))
                                .then(function (response) {
                                if (!response.ok) {
                                    throw new Error("Failed to fetch appSettings: ".concat(response.statusText));
                                }
                                return response.json();
                            })
                                .catch(function (error) {
                                console.error('Error loading appSettings:', error);
                                return null;
                            })];
                    case 1:
                        config = _g.sent();
                        if (config) {
                            this.options = {
                                autoForwardLogs: (_a = Boolean(config.autoForwardLogs)) !== null && _a !== void 0 ? _a : defaultOptions.autoForwardLogs,
                                enableLogs: (_b = Boolean(config.enableLogs)) !== null && _b !== void 0 ? _b : defaultOptions.enableLogs,
                                enableInfo: (_c = Boolean(config.enableInfo)) !== null && _c !== void 0 ? _c : defaultOptions.enableInfo,
                                enableWarn: (_d = Boolean(config.enableWarn)) !== null && _d !== void 0 ? _d : defaultOptions.enableWarn,
                                enableError: (_e = Boolean(config.enableError)) !== null && _e !== void 0 ? _e : defaultOptions.enableError,
                                enableDebug: (_f = Boolean(config.enableDebug)) !== null && _f !== void 0 ? _f : defaultOptions.enableDebug,
                            };
                        }
                        datadogLogs.init({
                            clientToken: 'pub8ca345149fb78b61aebd21383778f0e9', // Replace with your token
                            site: 'datadoghq.com', // Use 'datadoghq.eu' if in the EU
                            forwardErrorsToLogs: this.options.autoForwardLogs, // Automatically logs errors
                            forwardConsoleLogs: [], // Forward console logs
                            sampleRate: 100 // Adjust logging sample rate (0-100)
                        });
                        this.initialized = true;
                        this.overrideConsole();
                        this.info('DatadogLogger initialized with options: ' + JSON.stringify(this.options));
                        return [2 /*return*/];
                }
            });
        });
    };
    DatadogLogger.prototype.overrideConsole = function () {
        var self = this;
        var originalConsoleError = console.error;
        console.error = function consoleError() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var message = args.map(function (err) { return err.stack || err.toString(); }).join('\n');
            // Below are warning but React log it as error
            var suppressedPatterns = [
                'Support for defaultProps will be removed',
                'Each child in a list should have a unique "key"',
                'React has been loaded more than once',
                'Warning: '
            ];
            if (!self.options.enableWarn &&
                suppressedPatterns.some(function (p) { return message.includes(p); })) {
                return; // Skip logging
            }
            if (self.options.enableError) {
                // Log to Datadog manually if needed
                self.error('[console.error]', {
                    message: message,
                    args: args
                });
            }
            originalConsoleError.apply(console, args);
        };
        var originalConsoleWarn = console.warn;
        console.warn = function consoleWarning() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var message = args.join(' ');
            if (self.options.enableWarn) {
                // Log to Datadog manually if needed
                self.warn('[console.warn]', {
                    message: message,
                    args: args
                });
            }
            originalConsoleWarn.apply(console, args);
        };
        var originalConsoleInfo = console.info;
        console.info = function consoleInfo() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var message = args.join(' ');
            if (self.options.enableInfo) {
                // Log to Datadog manually if needed
                self.info('[console.info]', {
                    message: message,
                    args: args
                });
            }
            originalConsoleInfo.apply(console, args);
        };
        var originalConsoleDebug = console.debug;
        console.debug = function consoleDebug() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var message = args.join(' ');
            if (self.options.enableDebug) {
                // Log to Datadog manually if needed
                self.debug('[console.debug]', {
                    message: message,
                    args: args
                });
            }
            originalConsoleDebug.apply(console, args);
        };
        var originalConsoleLog = console.log;
        console.log = function consoleLog() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var message = args.join(' ');
            if (self.options.enableLogs) {
                // Log to Datadog manually if needed
                self.log('[console.log]', {
                    message: message,
                    args: args
                });
            }
            originalConsoleLog.apply(console, args);
        };
    };
    DatadogLogger.prototype.info = function (message, context) {
        if (this.options.enableInfo) {
            datadogLogs.logger.info(message, context);
        }
    };
    DatadogLogger.prototype.warn = function (message, context) {
        if (this.options.enableWarn) {
            datadogLogs.logger.warn(message, context);
        }
    };
    DatadogLogger.prototype.error = function (message, context) {
        if (this.options.enableError) {
            datadogLogs.logger.error(message, context);
        }
    };
    DatadogLogger.prototype.debug = function (message, context) {
        var _a, _b;
        if (this.options.enableDebug) {
            (_b = (_a = datadogLogs.logger).debug) === null || _b === void 0 ? void 0 : _b.call(_a, message, context);
        }
    };
    DatadogLogger.prototype.log = function (message, context) {
        var _a, _b;
        if (this.options.enableLogs) {
            (_b = (_a = datadogLogs.logger).log) === null || _b === void 0 ? void 0 : _b.call(_a, message, context);
        }
    };
    DatadogLogger.prototype.setOptions = function (options) {
        this.options = __assign(__assign({}, this.options), options);
    };
    return DatadogLogger;
}());
var datadogLogger = new DatadogLogger();
export default datadogLogger;
